import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";


export function emailSameValidator(originControl: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return originControl.value === control.value ? null : { emailNotSame: true };
  };
}
